import React from 'react';
import { Col, Flex, Row } from 'antd';

import BasePane from '@totem/components/BasePane';
import BulkTagButton from '@totem/components/software/software_report/bulkTagButton';
import TagsSection from '@totem/components/software/software_report/byTag/tagsSection';
import MergeButton from '@totem/components/software/software_report/mergeButton';
import SoftwareContainer from '@totem/components/software/software_report/softwareContainer';
import SoftwareFilters from '@totem/components/software/software_report/softwareFilters';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';

const styles = {
  inset: {
    marginLeft: '20px',
    marginRight: '20px',
  },
};

const SoftwareByTagsPage = () => {
  return (
    <ContentLayout>
      <BasePane>
        <PrimaryContentPane>
          <SoftwareContainer endPoint={`${DEVICES_ENDPOINT}/software/catalog`}>
            <br />
            <SoftwareFilters />
            <br />
            <br />
            <div style={styles.inset}>
              <Row>
                <Col span={12}>
                  <Flex justify={'flex-start'} align={'center'}>
                    <MergeButton />
                    <BulkTagButton isPrimary />
                  </Flex>
                </Col>
                <Col span={12}>
                  <Flex justify={'flex-end'} align={'center'}>
                    <span />
                  </Flex>
                </Col>
              </Row>
              <br />
              <TagsSection />
            </div>
          </SoftwareContainer>
        </PrimaryContentPane>
      </BasePane>
    </ContentLayout>
  );
};

export default SoftwareByTagsPage;
